@if (this.selectedWebhook) {
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <h3 i18n="@@webhook">Webhook:</h3>
    </div>
    <div class="d-flex align-items-center gap-3">
      <p-toggleswitch
        [(ngModel)]="this.selectedWebhook.enabled"
        (onChange)="this.rss.saveBotConfigField('toolConfigs')"
        />
      <app-skill-id-input
        [value]="this.selectedWebhook.skillId"
        (changed)="this.selectedWebhook.skillId = $event; this.rss.saveBotConfigField('toolConfigs')"
      ></app-skill-id-input>
    </div>
  </div>
  <div class="row align-items-center mt-3">
    <div class="col-3">
      <span i18n="@@name">Name</span>
    </div>
    <div class="col">
      <input
        pInputText
        [(ngModel)]="this.selectedWebhook.name"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
        fluid
        />
    </div>
    <div class="col-auto px-0">
      <i
        class="ri-arrow-left-circle-fill text-primary ri-2x cursor-pointer"
        (click)="selectPrevRule()"
      ></i>
    </div>
    <div class="col-auto px-0">
      {{ this.customWebhooks.indexOf(this.selectedWebhook) + 1 }} /
      {{this.customWebhooks.length}}
    </div>
    <div class="col-auto px-0">
      <i
        class="ri-arrow-right-circle-fill text-primary ri-2x cursor-pointer"
        (click)="selectNextRule()"
      ></i>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <span i18n="@@url">URL</span>
    </div>
    <div class="col">
      <input
        pInputText
        [(ngModel)]="this.selectedWebhook.url"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
        fluid
        >
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <span i18n="@@url-method">URL Methode</span>
    </div>
    <div class="col">
      <p-select
        [options]="urlMethodOptions"
        [(ngModel)]="this.selectedWebhook.urlMethod"
        (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
        optionLabel="label"
        optionValue="value"
        fluid
        >
      </p-select>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <span>Content-Type</span>
    </div>
    <div class="col">
      <p-select
        [(ngModel)]="this.selectedWebhook.contentType"
        (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
        [options]="contentTypesOptions"
        fluid
        >
      </p-select>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <span i18n="@@auth">Authorisierung</span>
    </div>
    <div class="col">
      <p-select
        [options]="authOptions"
        [(ngModel)]="selectedWebhook!.authMethod"
        optionLabel="label"
        optionValue="value"
        (ngModelChange)="rss.saveBotConfigField('toolConfigs')"
        fluid
      ></p-select>
    </div>
  </div>
  @if (this.selectedWebhook.authMethod === 'basic') {
    <div class="row mt-3">
      <div class="col-3">
        <span i18n="@@username">Benutzer</span>
      </div>
      <div class="col">
        <input
          pInputText
          type="text"
          [(ngModel)]="this.selectedWebhook.authData.user"
          [ngModelOptions]="{updateOn: 'blur'}"
          (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
          fluid
          >
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-3">
        <span i18n="@@password">Passwort</span>
      </div>
      <div class="col">
        <input
          pInputText
          type="text"
          [(ngModel)]="this.selectedWebhook.authData.password"
          [ngModelOptions]="{updateOn: 'blur'}"
          (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
          fluid
          >
      </div>
    </div>
  }
  <div class="row mt-3">
    <div class="col">
      <app-secret-placeholder-list></app-secret-placeholder-list>
    </div>
  </div>
}